import request from '@/utils/request';

const app = {
  fetchList() {
    return request({
      url: '/app/list',
      method: 'get'
    });
  },

  /**
   *
   * @param {appId} appId
   */
  fetchApp(appId) {
    const params = {appId: appId};
    return request({
      url: '/app',
      method: 'get',
      params
    });
  },

  /**
   * 上传前预检查：bundleId 是否已存在、是否属于当前用户
   * @param {bundleId, platform}
   */
  checkUpload(params) {
    return request({
      url: '/app/upload/check',
      method: 'get',
      params
    });
  },

  /**
   * 换取直传 COS 的预签名 URL
   * @param {platform, size}
   */
  signUpload(params) {
    return request({
      url: '/app/upload/sign',
      method: 'get',
      params
    });
  },

  create(data) {
    return request({
      url: '/app/create',
      method: 'post',
      data
    });
  },
  update(data) {
    return request({
      url: '/app/update',
      method: 'post',
      data
    });
  },
  fetchVersionList(appId, page, size) {
    const params = {appId: appId, page: page, size: size};
    return request({
      url: '/app/version/list',
      method: 'get',
      params
    });
  },
  versionCreate(data) {
    return request({
      url: '/app/version/create',
      method: 'post',
      data
    });
  },
  //vdesc/branch/verId
  versionUpdate(data) {
    return request({
      url: '/app/version/update',
      method: 'post',
      data
    });
  },
  //verId
  versionDelete(verId) {
    const data = {verId: verId};
    return request({
      url: '/app/version/delete',
      method: 'post',
      data
    });
  },
  //verId
  versionDefault(data) {
    return request({
      url: '/app/version/default',
      method: 'post',
      data
    });
  },
  versionInstallUrl(data) {
    return request({
      url: '/app/version/install-url',
      method: 'get',
      params: data
    });
  },
  release(data) {
    return request({
      url: '/app/release',
      method: 'get',
      params: data
    });
  },
  delete(appId) {
    return request({
      url: '/app/delete',
      method: 'post',
      data: {
        appId: appId
      }
    });
  }
};

export default app;
